import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import { FaInstagram, FaWhatsapp, FaShoppingCart } from "react-icons/fa";
import 'react-toastify/dist/ReactToastify.css';
import "./App.css";
import Header from "./Header";
import HomePage from "./HomePage";
import Footer from "./Footer";
import ProductPage from "./ProductPage";
import CartPage from "./CartPage";
import CheckoutPage from "./CheckoutPage";
import { CartProvider, CartContext } from "./CartContext";
import ThanksPage from "./ThanksPage";
import CategoryPage from "./CategoryPage";
import CategoryPreview from "./CategoryPreview";
import BestSellingProducts from "./BestSellingProducts";
import BestSellingPage from "./BestSellingPage";
import LatestProducts from "./LatestProducts";
import LatestPage from "./LatestPage";
import CategoriesSection from "./CategoriesSection";
import CategoriesPage from "./CategoriesPage";

function AppContent() {
  const { cart } = React.useContext(CartContext);

  return (
    <Router>
      <div className="app">
        <Header />

        <main className="main-content">
          <ToastContainer
            position="top-left"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={true}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
            style={{ fontFamily: 'inherit', fontSize: '14px' }}
          />
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <HomePage />
                  <CategoryPreview
                    categoryId={139}
                    title="عروض خاصه"
                    link="/category/139"
                  />
                  <BestSellingProducts />
                  <LatestProducts />
                  <CategoriesSection />
                </>
              }
            />
            <Route path="/product/:id" element={<ProductPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/thanks" element={<ThanksPage />} />
            <Route path="/category/:id" element={<CategoryPage />} />
            <Route path="/bestselling" element={<BestSellingPage />} />
            <Route path="/latest" element={<LatestPage />} />
            <Route path="/categories" element={<CategoriesPage />} />
          </Routes>
        </main>

        {/* Mobile Bottom Bar */}
        <div className="mobile-bottom-bar">
          <Link to="/checkout">
            <FaShoppingCart size={20} />
            <span>العربة</span>
            <span className="cart-badge">{cart.length > 0 ? cart.length : ''}</span>
          </Link>
          <a href="https://api.whatsapp.com/send/?phone=96594432382" target="_blank" rel="noreferrer">
            <FaWhatsapp size={20} />
            <span>واتساب</span>
          </a>
          <a href="https://www.instagram.com/floriakwt" target="_blank" rel="noreferrer">
            <FaInstagram size={20} />
            <span>انستجرام</span>
          </a>
        </div>

        <Footer />
      </div>
    </Router>
  );
}

function App() {
  return (
    <CartProvider>
      <AppContent />
    </CartProvider>
  );
}

export default App;
